import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=54603627&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=54603627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54603627",
  null
  
)

export default component.exports